<template>
  <div>
    <div
      class="textBox"
      v-if="textArr.length"
    >
      <div class="line"></div>
      <transition name="slide">
        <p
          class="text"
          :key="text.id"
          @click="openNew(text.id)"
        >{{text.title}}</p>
      </transition>
    </div>
  </div>
</template>

<script>
import { get_roll_news_list } from "../services/selectSide"
export default {
  name: "Notice",
  data() {
    return {
      textArr: [],
      number: 0
    }
  },
  computed: {
    text() {
      return {
        id: this.textArr[this.number] ? this.textArr[this.number].id : 0,
        title: this.textArr[this.number] ? this.textArr[this.number].title : '',
      }
    }
  },
  created() {
    get_roll_news_list({ content: JSON.stringify({ limit: 100 }) }).then((res) => {
      console.log(res)
      if (res.code == 1) {
        this.textArr = res.data;
        console.log(this.textArr[this.number].id)
        this.startMove(this.textArr[this.number].roll_time)
      }
    })
  },
  methods: {
    startMove(time) {
      // eslint-disable-next-line
      let timer = setTimeout(() => {
        this.number += 1;
        if (this.number === this.textArr.length) {
          this.number = 0;
        }
        this.startMove(this.textArr[this.number].roll_time);
      }, time); // 滚动不需要停顿则将2000改成动画持续时间
    },
    openNew(id) {
      var dataObj = ''
      this.textArr.forEach((item) => {
        if (item.id == id) {
          dataObj = item
        }
      })
      this.$emit('clickNotice', dataObj)
    }
  }
}
</script>


<style scoped lang="scss">
.textBox {
  width: 100%;
  height: 40px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  text-align: center;
  background: $bg-color;
  color: #fff;
  cursor: pointer;
}
.line {
  position: absolute;
  left: 30px;
  width: 2px;
  height: 30px;
  top: 5px;
  background: #fff;
}
.text {
  width: 100%;
  position: absolute;
  height: 40px;
  line-height: 40px;
  text-align: left;
  left: 30px;
  padding-left: 30px;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.8s linear;
}
.slide-enter {
  transform: translateY(20px) scale(1);
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(-20px) scale(0.8);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue